module.exports = __webpack_public_path__ + "static/img/yl.0d8988a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yl.png
// module id = FIED
// module chunks = 0